import {Component, OnInit} from '@angular/core';
import {FormBuilder, Validators} from '@angular/forms';
import {passwordMatchValidator} from '../../_validators/validators';
import {AuthenticationService} from '../../_services';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-password-reset',
  templateUrl: './password-reset.component.html',
  styleUrls: ['./password-reset.component.css']
})
export class PasswordResetComponent implements OnInit {
  public resetPasswordForm: any;
  private token: string;
  public error: '';
  public success: '';
  public serverResponse: any;
  public resettingPassword: boolean;

  constructor(
    private formBuilder: FormBuilder,
    private authenticationService: AuthenticationService,
    private route: ActivatedRoute
  ) {
    this.resetPasswordForm = this.formBuilder.group({
      token: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(6)]],
      password: ['', [Validators.required, Validators.minLength(8)]],
      password_confirmation: ['', [Validators.required, passwordMatchValidator]]
    });

    this.d.password.valueChanges
      .subscribe(c => this.d.password_confirmation.updateValueAndValidity());
  }

  ngOnInit(): void {
    // this.token = this.route.snapshot.queryParams.sign;
  }

  get d() {
    return this.resetPasswordForm.controls;
  }

  resetPassword() {
    this.resettingPassword = true;
    return this.authenticationService.resetPassword(this.d.password.value, this.d.password_confirmation.value, this.d.token.value)
      .subscribe(resp => {
        this.serverResponse = resp;
        if (this.serverResponse.success === false) {
          this.resettingPassword = false;
          this.success = '';
          this.error = this.serverResponse.data;
        } else {
          this.resettingPassword = false;
          this.error = '';
          this.success = this.serverResponse.data;
        }
      });
  }
}
